import type { PayoutDraftState } from 'models/payoutDrafts';
import { PAYOUT_DRAFTS_STATUS } from 'models/payoutDrafts';

export const PAYOUT_DRAFTS_TITLE_TEST_ID = 'title-payout-drafts';
export const PAYOUT_DRAFTS_TABLE_TEST_ID = 'payout-drafts-table';
export const PAYOUT_DRAFTS_TABLE_ROW_ENTRY_TEST_ID =
  'payout-drafts-table-row-entry';
export const PAYOUT_DRAFTS_STATUS_FILTER_TEST_ID =
  'payout-drafts-statuses-filters';

export const PAYOUT_DRAFTS_DETAILS_TEST_ID = 'payout-drafts-details';
export const PAYOUT_DRAFTS_DETAILS_HEADER_PAYOUT_REQUEST_TEST_ID =
  'payout-draft-details-header-payout-request';
export const PAYOUT_DRAFTS_DETAILS_DELETE_BUTTON_TEST_ID =
  'payout-drafts-details-button-delete';
export const PAYOUT_DRAFT_DETAILS_CONFIRM_DELETE_BUTTON_TEST_ID =
  'payout-drafts-details-button-delete-confirm';

export const PAYOUT_DRAFTS_STATUSES: Array<PayoutDraftState> = [
  {
    id: 'waiting_review',
    value: PAYOUT_DRAFTS_STATUS.WAITING_REVIEW,
    order: 1,
    label: 'Pending approval',
    style: {
      color: 'bg-status-pending',
      activeColor: 'bg-status-pending-active',
      hover: 'hover:bg-status-pending-active'
    }
  },
  {
    id: 'rejected',
    value: PAYOUT_DRAFTS_STATUS.REJECTED,
    order: 2,
    label: 'Declined',
    style: {
      color: 'bg-status-negative',
      activeColor: 'bg-status-negative-active',
      hover: 'hover:bg-status-negative-active'
    }
  }
];

export const PAYOUT_DRAFT_SOURCES = ['manual', 'batch'];
